import {BrandPreview} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand_preview.types';

export interface BrandPreviewEntity {
  brandPreview: BrandPreview;
}

export const isBrandPreviewEntities = (
  entities: BrandPreviewEntity | {[key: string]: unknown},
): entities is BrandPreviewEntity => {
  const brandPreview = entities.brandPreview as BrandPreview;
  return Boolean(brandPreview && brandPreview.type?.$case === 'images');
};
